export default __webpack_public_path__ + "static/media/battery.4d676bdf.svg";